import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { get, del } from '../api';
import TerrainMapPreview from '../components/TerrainMapPreview/TerrainMapPreview';

interface CustomMapEntry {
  id: string;
  name: string;
  description: string;
  width: number;
  height: number;
  terrainData: { [key: string]: string };
}

export default function EditorPage() {
  const [maps, setMaps] = useState<CustomMapEntry[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = () => {
    setLoading(true);
    get('custom-maps')
      .then(setMaps)
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(refresh, []);

  const handleDelete = async (id: string) => {
    if (!window.confirm('Delete this map? This cannot be undone.')) {
      return;
    }
    await del(`custom-maps/${id}`);
    refresh();
  };

  return (
    <div>
      <div
        className="is-flex is-justify-content-space-between is-align-items-center mb-4"
        style={{ gap: 12 }}
      >
        <h1 className="title mb-0">My Maps</h1>
        <Link className="button is-primary" to="/editor/new">
          New Map
        </Link>
      </div>

      {loading && <p style={{ color: 'var(--text-muted)' }}>Loading…</p>}
      {!loading && maps.length === 0 && (
        <p style={{ color: 'var(--text-muted)' }}>
          You haven't created any maps yet.
        </p>
      )}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: 16,
        }}
      >
        {maps.map((map) => (
          <div
            key={map.id}
            className="box"
            style={{
              borderRadius: 8,
              padding: '16px 16px 14px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <h3
              style={{
                fontSize: '1rem',
                fontWeight: 600,
                wordBreak: 'break-word',
                lineHeight: 1.3,
                marginBottom: 4,
              }}
            >
              {map.name}
            </h3>
            <p
              style={{
                fontSize: '0.8rem',
                color: 'var(--text-muted)',
                marginBottom: 10,
              }}
            >
              {map.description}
            </p>

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 12,
              }}
            >
              <TerrainMapPreview
                terrainMap={{
                  width: map.width,
                  height: map.height,
                  data: map.terrainData,
                }}
                cellSize={4}
                highlightOwners={false}
              />
            </div>

            <div
              className="is-flex is-justify-content-space-between"
              style={{ marginTop: 'auto', gap: 6 }}
            >
              <Link
                className="button is-small is-light"
                to={`/editor/${map.id}`}
              >
                Edit
              </Link>
              <button
                className="button is-small is-danger is-light"
                onClick={() => handleDelete(map.id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
